import { useQuery } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

export const usersSummaryByIdsQueryKeys = {
  all: ['users-summary-by-ids'] as const,
  list: (ids: Array<string>, brand: string) => [...usersSummaryByIdsQueryKeys.all, ids, brand] as const,
};

const FIVE_MINUTES = 5 * 60 * 1000;

export function useGetUsersSummaryByIds(ids: Array<string>, brand: string) {
  return useQuery({
    queryKey: usersSummaryByIdsQueryKeys.list(ids, brand),
    queryFn: async () => {
      if (ids.filter(Boolean).length === 0) {
        return new Map();
      }
      return await UsersService.getUsersSummaryByIds(ids, brand);
    },
    enabled: ids.length > 0 && !!brand,
    staleTime: FIVE_MINUTES,
  });
}
